import { render } from "./StaffDataTable.vue?vue&type=template&id=9943c91a&scoped=true"
import script from "./StaffDataTable.vue?vue&type=script&lang=js"
export * from "./StaffDataTable.vue?vue&type=script&lang=js"

import "./StaffDataTable.vue?vue&type=style&index=0&id=9943c91a&scoped=true&lang=css"
import "./StaffDataTable.vue?vue&type=style&index=1&id=9943c91a&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9943c91a"]])

export default __exports__